"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _splice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/splice"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

require("../../../util/GlobalScript.js");

var _MultiDragActions = _interopRequireDefault(require("./MultiDragActions"));

var _clone = _interopRequireDefault(require("clone"));

var _reMutable = _interopRequireDefault(require("re-mutable"));

var _FilterUtils = _interopRequireDefault(require("../../../util/FilterUtils.js"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = (0, _filter.default)(symbols).call(symbols, function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context5; (0, _forEach.default)(_context5 = ownKeys(Object(source), true)).call(_context5, function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { var _context6; (0, _forEach.default)(_context6 = ownKeys(Object(source))).call(_context6, function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

var initialState = {
  columns: []
};
/**
 * @typedef {object} MultiDrag~searchAction
 *
 * @property {string} fieldName
 *    The field name to use in the search.
 * @property {number} column
 *    The index of the column whose rows to search.
 * @property {string} filter
 *    The value of the filter string to use in the search.
 */

/**
 * @function MultiDrag~setSearch
 *
 * @desc Sets search filter for column rows
 *
 * @param {object} state
 *    The state to apply the search to. Can be a clone of the current state
 *    or some next state that is the result of other actions that already changed the current state.
 * @param {MultiDrag~searchAction} action
 *    The search action object to use in the search.
 *
 * @return {object}
 *    The next state
 */

function setSearch(state, action) {
  var searchStr = (0, _filter.default)(action) || "";
  return (0, _reMutable.default)(state).set(["columns", action.column, "search"], searchStr).set(["columns", action.column, "searchFieldName"], action.fieldName).end();
}
/**
 * @function MultiDrag~applyFilters
 *
 * @desc Apply all the current filters in the state
 *
 * @param {object} state
 *    The state to reapply all current state's filters to. Can be a clone of the current state
 *    or some next state that is the result of other actions that already changed the current state.
 *
 * @return {object}
 *    The next state will all the current state's filters applied.
 */


function applyFilters(state, transform) {
  var _context, _context3;

  var next = state;
  (0, _forEach.default)(_context = next.columns).call(_context, function (column, index) {
    var searchStr = column.search || "";

    var searchFn = _FilterUtils.default.getFilterFunction(searchStr, column.searchFieldName);

    var categoryStr = column.category || "";

    var categoryFn = function categoryFn(item) {
      return categoryStr === "" || (item.categoryId || item.category) === categoryStr;
    };

    var filterFn = function filterFn(item) {
      return searchFn(item) && categoryFn(item);
    };

    if ((searchStr + categoryStr).length > 0) {
      var _context2;

      next = _reMutable.default.set(next, ["columns", index, "filteredRows"], (0, _filter.default)(_context2 = column.rows).call(_context2, filterFn));
    } else {
      next = _reMutable.default.set(next, ["columns", index, "filteredRows"], column.rows);
    }
  });
  return transform ? _objectSpread(_objectSpread({}, next), {}, {
    columns: (0, _map.default)(_context3 = next.columns).call(_context3, function (_ref) {
      var filteredRows = _ref.filteredRows,
          rows = _ref.rows,
          column = (0, _objectWithoutProperties2.default)(_ref, ["filteredRows", "rows"]);
      return _objectSpread({
        filteredRows: transform(filteredRows),
        rows: transform(rows)
      }, column);
    })
  }) : next;
}
/**
 * @function MultiDrag~search
 *
 * @desc Applies filters to the rows in the specified column's state
 *    by searching each row's field name for the filter value.
 *
 * @param {object} state
 *    The state to apply the search to. Can be a clone of the current state
 *    or some next state that is the result of other actions that already changed the current state.
 * @param {MultiDrag~searchAction} action
 *    The search action object to use in the search.
 *
 * @return {object}
 *    The next state with the filters applied.
 */


function search(state, action) {
  return applyFilters(setSearch(state, action));
}
/**
 * @typedef {object} MultiDrag~moveAction
 *
 * @property {MultiDrag~MoveObject} from
 *    The dragged MultiDrag~MoveObject.
 * @property {MultiDrag~MoveObject} to
 *    The target MultiDrag~MoveObject.
 */

/**
 * @function MultiDrag~move
 *
 * @desc Applies the move to the state of the source and destination columns.
 *
 * @param {object} state
 *    The state to apply the move to. Can be a clone of the current state
 *    or some next state that is the result of other actions that already changed the current state.
 * @param {MultiDrag~moveAction} action
 *    The move action object to use in the move.
 *
 * @return {object}
 *    The next state with the move applied.
 */


function move(state, action) {
  var _context4;

  var row = state.columns[action.from.column].rows[action.from.index];
  return (0, _splice.default)(_context4 = (0, _reMutable.default)(state).unset(["columns", action.from.column, "rows", action.from.index])).call(_context4, ["columns", action.to.column, "rows"], action.to.index, 0, row).unset(["placeholder"]).end();
}
/**
 * @typedef {object} MultiDrag~initAction
 * @private
 * @ignore
 *
 * @property {object[]} data
 *    The columns data to initialize the state with.
 */

/**
 * @function MultiDrag~init
 * @private
 * @ignore
 *
 * @desc Initializes the state's columns.
 *
 * @param {object} state
 *    The state to apply the initialization to. Can be a clone of the current state
 *    or some next state that is the result of other actions that already changed the current state.
 * @param {MultiDrag~initAction} action
 *    The init action object to use in the initialization.
 *
 * @return {object}
 *    The next state with the initialization applied.
 */


function init(state, action) {
  return _reMutable.default.set(state, ["columns"], (0, _clone.default)(action.data));
}

module.exports = function (state, action) {
  var next;

  switch (action.type) {
    case _MultiDragActions.default.Types.MULTIDRAG_SET:
      next = _reMutable.default.set(state, action.path, action.value);
      break;

    case _MultiDragActions.default.Types.MULTIDRAG_MOVE:
      next = move(state, action);
      break;

    case _MultiDragActions.default.Types.MULTIDRAG_FILTER:
      next = setSearch(state, action);
      break;

    case _MultiDragActions.default.Types.MULTIDRAG_INIT:
      next = init(state, action);
      break;

    case _MultiDragActions.default.Types.MULTIDRAG_APPEND:
      next = (0, _concat.default)(_reMutable.default).call(_reMutable.default, state, ["columns", action.column, "rows"], action.data);
      break;

    case _MultiDragActions.default.Types.MULTIDRAG_PREPEND:
      next = _reMutable.default.prepend(state, ["columns", action.column, "rows"], action.data);
      break;

    default:
      return state || initialState;
  } //since we render based on the filteredRows property, update them after a move.  If there is
  //no filter search() will return a reference to rows


  next = applyFilters(next);
  return next;
};

module.exports.search = search;
module.exports.move = move;
module.exports.reapplyFilters = applyFilters;